// frontend/modules/customer-loan-info/components/CustomerLoanSearchForm.tsx
import React, { useState } from 'react';
import { Card, Form, Input, Button, DatePicker, Space, Typography } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { CustomerLoanSearchParams } from '../types';
import dayjs from 'dayjs';

const { Title } = Typography;

interface CustomerLoanSearchFormProps {
  onSearch: (params: CustomerLoanSearchParams) => void;
  onClear: () => void;
  loading?: boolean;
}

export const CustomerLoanSearchForm: React.FC<CustomerLoanSearchFormProps> = ({
  onSearch,
  onClear,
  loading = false
}) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);

  const handleValuesChange = () => {
    const values = form.getFieldsValue();
    const isValid = values.branch && values.custNo && values.glNo;
    setIsFormValid(isValid);
  };

  const handleSubmit = (values: any) => {
    const searchParams: CustomerLoanSearchParams = {
      branch: values.branch,
      custNo: values.custNo,
      glNo: values.glNo,
      transactionDate: values.transactionDate ? dayjs(values.transactionDate).format('YYYY-MM-DD') : undefined
    };
    onSearch(searchParams);
  };

  const handleClear = () => {
    form.resetFields();
    setIsFormValid(false);
    onClear();
  };

  return (
    <Card>
      <Title level={4}>Search Customer Loan Information</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        onValuesChange={handleValuesChange}
      >
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
          <Form.Item
            name="branch"
            label="Branch Code"
            rules={[{ required: true, message: 'Please enter branch code' }]}
          >
            <Input placeholder="Enter branch code" />
          </Form.Item>

          <Form.Item
            name="custNo"
            label="Customer Number"
            rules={[{ required: true, message: 'Please enter customer number' }]}
          >
            <Input placeholder="Enter customer number" />
          </Form.Item>

          <Form.Item
            name="glNo"
            label="GL Number"
            rules={[{ required: true, message: 'Please enter GL number' }]}
          >
            <Input placeholder="Enter GL number" />
          </Form.Item>

          <Form.Item
            name="transactionDate"
            label="Transaction Date (Optional)"
          >
            <DatePicker 
              style={{ width: '100%' }}
              placeholder="Select date"
              format="YYYY-MM-DD"
            />
          </Form.Item>
        </div>

        <Space>
          <Button
            type="primary"
            htmlType="submit"
            icon={<SearchOutlined />}
            loading={loading}
            disabled={!isFormValid}
          >
            Search Loan Information
          </Button>
          <Button
            icon={<ClearOutlined />}
            onClick={handleClear}
          >
            Clear
          </Button>
        </Space>
      </Form>
    </Card>
  );
};
